exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-table-total[data-v-6ff9e34a] {\n  /*font-weight: bold;\n  font-size: 18px;*/\n}\n.cart-table-vat ul[data-v-6ff9e34a] {\n  margin-bottom:0px;\n}\n.cart-table-vat ul li[data-v-6ff9e34a]{\n  font-weight: 300;\n    font-size: initial;\n    list-style: none;\n}\n", ""]);

// exports
